// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_WgWyU","bgnone":"index_bgnone_hUbAb","ssr_nav":"index_ssr_nav_8OKFH","smallLineBox":"index_smallLineBox_czENX"};